var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api } from 'api';
import { useState, useCallback, useEffect, useRef } from 'react';
import { useNotification } from '../../notifications';
export var useSaveAttachment = function () {
    var liveNotification = useNotification().liveNotification;
    var _a = useState({}), attachmentsStatus = _a[0], setAttachmentsStatus = _a[1];
    var _b = useState({}), attachmentsError = _b[0], setAttachmentsError = _b[1];
    var _c = useState({}), attachmentsData = _c[0], setAttachmentsData = _c[1];
    var abortControllers = useRef(new Map());
    var execute = useCallback(function (attachment) { return __awaiter(void 0, void 0, void 0, function () {
        var offerId, fileName, file, attachmentKey, controller, signal, response_1, error_1, errorMsg_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    offerId = attachment.offerId, fileName = attachment.fileName, file = attachment.file;
                    if (!offerId)
                        return [2 /*return*/];
                    attachmentKey = "".concat(offerId, "-").concat(fileName);
                    if (abortControllers.current.has(attachmentKey)) {
                        abortControllers.current.get(attachmentKey).abort();
                    }
                    controller = new AbortController();
                    signal = controller.signal;
                    abortControllers.current.set(attachmentKey, controller);
                    setAttachmentsStatus(function (prevStatus) {
                        var _a;
                        return (__assign(__assign({}, prevStatus), (_a = {}, _a[attachmentKey] = 'loading', _a)));
                    });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api.utils.apiUtilsUploadAttachmentIdPost(offerId, fileName, file, { signal: signal })];
                case 2:
                    response_1 = _c.sent();
                    setAttachmentsData(function (prevData) {
                        var _a;
                        return (__assign(__assign({}, prevData), (_a = {}, _a[attachmentKey] = response_1.data, _a)));
                    });
                    setAttachmentsStatus(function (prevStatus) {
                        var _a;
                        return (__assign(__assign({}, prevStatus), (_a = {}, _a[attachmentKey] = 'fetched', _a)));
                    });
                    setAttachmentsError(function (prevError) {
                        var _a;
                        return (__assign(__assign({}, prevError), (_a = {}, _a[attachmentKey] = null, _a)));
                    });
                    liveNotification('success', "Attachment ".concat(fileName, " saved successfully"));
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    if (!signal.aborted) {
                        errorMsg_1 = ((_b = (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || error_1.message;
                        setAttachmentsStatus(function (prevStatus) {
                            var _a;
                            return (__assign(__assign({}, prevStatus), (_a = {}, _a[attachmentKey] = 'error', _a)));
                        });
                        setAttachmentsError(function (prevError) {
                            var _a;
                            return (__assign(__assign({}, prevError), (_a = {}, _a[attachmentKey] = errorMsg_1, _a)));
                        });
                        liveNotification('error', "Error saving attachment ".concat(fileName, ": ").concat(errorMsg_1));
                    }
                    else {
                        console.log("Save request for attachment ".concat(fileName, " was aborted"));
                    }
                    return [3 /*break*/, 5];
                case 4:
                    abortControllers.current.delete(attachmentKey);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [liveNotification]);
    useEffect(function () {
        return function () {
            abortControllers.current.forEach(function (controller) { return controller.abort(); });
            abortControllers.current.clear();
            setAttachmentsStatus({});
            setAttachmentsError({});
            setAttachmentsData({});
        };
    }, []);
    return { attachmentsStatus: attachmentsStatus, attachmentsError: attachmentsError, attachmentsData: attachmentsData, execute: execute };
};
